export const money = (n) =>
  `JMD $${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const moneyShort = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

// Date-only values (YYYY-MM-DD business dates such as sale_date / due_date) must NOT be parsed as UTC midnight:
// new Date("2026-09-30") renders as 29 Sept in Jamaica (UTC-5). Parse them as a local calendar date instead.
export const parseDate = (d) => (typeof d === "string" && /^\d{4}-\d{2}-\d{2}$/.test(d) ? new Date(`${d}T00:00:00`) : new Date(d));

export const fmtDate = (d) => {
  if (!d) return "-";
  try {
    return parseDate(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const statusColor = (status) => {
  switch (status) {
    case "Paid": return "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30";
    case "Current": return "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/30";
    case "Due Soon": return "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30";
    case "Due Today": return "bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/30";
    case "Overdue": return "bg-rose-500/15 text-rose-600 dark:text-rose-400 border-rose-500/30";
    case "Partially Paid": return "bg-violet-500/15 text-violet-600 dark:text-violet-400 border-violet-500/30";
    case "Written Off": return "bg-slate-500/15 text-slate-500 border-slate-500/30";
    default: return "bg-muted text-muted-foreground border-border";
  }
};
